import React, { useState, useEffect, forwardRef } from 'react';
import styled from 'styled-components';

import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Slide,
	IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import BarStepper from './BarStepper';
import Analyseauswertung from '../modals/content/Analyseauswertung';
import IhrOptimiertesSystem from '../modals/content/IhrOptimiertesSystem';
import IhrePotentielleEinsparung from '../modals/content/IhrePotentielleEinsparung';
import PvAnlageUndBatteriespeicher from '../modals/content/PvAnlageUndBatteriespeicher';
import EigenverbrauchOptimiert from '../modals/content/EigenverbrauchOptimiert';
import EigenverbrauchPotentielleEinsparung from '../modals/content/EigenverbrauchPotentielleEinsparung';
import BtnPrimary from '../common/BtnPrimary';
import ModalFormContact from '../modals/ModalFormContact';

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const RootDialog = styled(Dialog)`
	.MuiDialogTitle-root {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.MuiDialogActions-root {
		padding: 20px;
	}

	/* .iconContainer {
		margin-right: 142px;
	}

	.MuiBackdrop-root {
		background-color: rgba(64, 151, 163, 0.8);
	}

	.MuiPaper-root {
		padding: 40px;
	}

	.MuiDialogActions-root,
	.MuiDialogTitle-root,
	.MuiDialogActions-root {
		padding: 0;
	}

	.MuiDialogContent-root {
		padding-left: 0;
		padding-right: 0;
		overflow-x: hidden;
	} */
`;

const DialogDashboardTiles = ({
	open,
	close,
	selectedValue,
	currentSelectedValue,
	currentCase,
	data,
	isStoragePark,
}) => {
	const [value, setValue] = useState(selectedValue);
	const [openContact, setOpenContact] = useState(false);
	const maxTabs = 3;
	let Content = null;
	const BtnText = ['Zur Batterie', 'Zur Einsparung', 'Zur Beratung'];

	useEffect(() => {
		setValue(selectedValue);
	}, [selectedValue]);

	const handleSelection = (e) => {
		if (e >= maxTabs) {
			close();
			setOpenContact(true);
		} else {
			setValue(e);
			currentSelectedValue(e);
		}
	};

	switch (currentCase) {
		case true:
			// Netzentgelte
			Content = (
				<>
					{value === 0 ? <Analyseauswertung data={data} /> : null}
					{value === 1 ? (
						<IhrOptimiertesSystem isStoragePark={isStoragePark} data={data} />
					) : null}
					{value === 2 ? <IhrePotentielleEinsparung data={data} /> : null}
				</>
			);
			break;

		case false:
			// Eigenverbrauch
			Content = (
				<>
					{value === 0 ? <PvAnlageUndBatteriespeicher data={data} /> : null}
					{value === 1 ? (
						<EigenverbrauchOptimiert
							isStoragePark={isStoragePark}
							data={data}
						/>
					) : null}
					{value === 2 ? (
						<EigenverbrauchPotentielleEinsparung data={data} />
					) : null}
				</>
			);
			break;

		default:
			break;
	}

	return (
		<>
			<ModalFormContact
				open={openContact}
				closeModal={() => setOpenContact(false)}
			/>
			<RootDialog
				open={open}
				onClose={close}
				maxWidth="lg"
				TransitionComponent={Transition}
			>
				<DialogTitle disableTypography>
					<BarStepper
						selectedValue={(e) => handleSelection(e)}
						currentSelected={value}
					/>
					<IconButton onClick={close}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent>{Content}</DialogContent>
				<DialogActions>
					<BtnPrimary onClick={() => handleSelection(value + 1)}>
						{BtnText[value]}
					</BtnPrimary>
				</DialogActions>
			</RootDialog>
		</>
	);
};

export default DialogDashboardTiles;
